import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Tabs } from '../components/tabs';

import { TariffPlanTab } from './tariff/plan-tab';
import { BonusesTab } from './tariff/bonuses-tab';
import { PaymentHistoryTab } from './tariff/payment-history-tab';

const Tariffs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { activeTabId?: string } | null;
  const defaultActiveTabId =
    state?.activeTabId === 'plan' || state?.activeTabId === 'bonuses' || state?.activeTabId === 'history'
      ? state.activeTabId
      : undefined;

  useEffect(() => {
    if (!defaultActiveTabId) return;

    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [defaultActiveTabId, location.pathname, location.search, navigate]);

  return (
    <Tabs
      defaultActiveId={defaultActiveTabId}
      tabs={[
        {
          id: 'plan',
          title: 'Выбор тарифа',
          content: <TariffPlanTab />,
          isActive: !defaultActiveTabId || defaultActiveTabId === 'plan',
        },
        {
          id: 'bonuses',
          title: 'Бонусные рубли',
          content: <BonusesTab />,
          isActive: defaultActiveTabId === 'bonuses',
        },
        {
          id: 'history',
          title: 'История платежей',
          content: <PaymentHistoryTab />,
          isActive: defaultActiveTabId === 'history',
        },
      ]}
    />
  );
};

export default Tariffs;
